import script from "./gameDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./gameDetail.vue?vue&type=script&setup=true&lang=js"

import "./gameDetail.vue?vue&type=style&index=0&id=65422154&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65422154"]])

export default __exports__